export const COUNTERPARTY_ADMIN_ROLE_ID = 1;
export const COUNTERPARTY_MANAGER_TYPE_ID = 5;
